/* eslint-disable import/no-named-as-default-member */
/* eslint-disable import/no-named-as-default */
import { withStyles } from '@mui/styles';
import Component from './Component';
import styles from './styles';

const Styled = withStyles(styles)(Component);

export default Styled;
